import PropTypes from 'prop-types';
import { DB_PREFIX } from './constants';

export default PropTypes.shape({
  [DB_PREFIX]: PropTypes.shape({
    isGroup: PropTypes.bool,
    users: PropTypes.arrayOf(
      PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
      })
    ).isRequired,
  }),
});
